

import {Vue, Component, Prop} from "vue-property-decorator";
import TeacherIcon from "src/modules/teacher/TeacherIcon.vue";
import { getAssetItem } from "src/utils/helpers";

@Component({
  components: {TeacherIcon},
  methods: {getAssetItem}
  })
export default class OnboardingSlide extends Vue {
  @Prop({default: 'onboarding/welcome.webp'}) imageUrl!: string;
  @Prop({default: false}) noBackButton!: boolean;
  @Prop({default: false}) hideTeacher!: boolean;
}
